//@ts-nocheck

const header = (): void => {
	const btn = document.querySelector(".js-hamburger");
	const closeBtn = document.querySelector(".js-close-navigation");
	const header = document.querySelector(".js-header");
	const navigationContainer = document.querySelector(
		".js-navigation-container"
	);
	const navigations = document.querySelector(".js-navigations");

	if (!header || !btn || !closeBtn || !navigationContainer || !navigations)
		return;

	const menuItemsWithSubmenues = header.querySelectorAll(
		".menu-item-has-children"
	);
	if (menuItemsWithSubmenues.length > 0) {
		menuItemsWithSubmenues.forEach((item) => {
			const link = item.querySelector("a");
			const submenu = item.querySelector("ul.sub-menu");
			if (!link || !submenu) return;

			const siblingElements = Array.from(item.parentElement.children);
			let hoverTimeout;
			item.addEventListener("mouseenter", () => {
				clearTimeout(hoverTimeout);
				item.classList.add("hovered");
				item.setAttribute("aria-expanded", "true");
				siblingElements.forEach((sibling) => {
					if (
						sibling !== item &&
						sibling.classList.contains("menu-item-has-children")
					) {
						sibling.classList.remove("hovered");
					}
				});
			});
			item.addEventListener("mouseleave", () => {
				hoverTimeout = setTimeout(() => {
					item.classList.remove("hovered");
					item.setAttribute("aria-expanded", "false");					
				}, 500);
			});
			item.addEventListener("focusin", () => {
				clearTimeout(hoverTimeout);
				item.classList.add("hovered");
				siblingElements.forEach((sibling) => {
					if (
						sibling !== item &&
						sibling.classList.contains("menu-item-has-children")
					) {
						sibling.classList.remove("hovered");
					}
				});
			});
			item.addEventListener("focusout", () => {
				hoverTimeout = setTimeout(() => {
					item.classList.remove("hovered");
				}, 500);
			});

			const btn = document.createElement("button");
			btn.setAttribute("aria-label", "Dropdown Button");
			btn.setAttribute("aria-haspopup", "true");
			btn.setAttribute("aria-expanded", "false");
			btn.classList.add("submenu-btn");
			link.append(btn);

			btn.addEventListener("click", (e) => {
				e.preventDefault();
				e.stopImmediatePropagation();
				e.stopPropagation();
				item.classList.toggle("open-submenu");
			});
		});
	}

	navigationContainer.addEventListener("click", (e) => {
		if (e.target !== navigations && !navigations.contains(e.target)) {
			header.classList.remove("open");
			document.documentElement.classList.remove("open");
		}
	});

	closeBtn.addEventListener("click", () => {
		header.classList.remove("open");
		document.documentElement.classList.remove("open");
	});

	btn.addEventListener("click", () => {
		header.classList.add("open");
		document.documentElement.classList.add("open");
	});

	let prevPosY = window.scrollY;

	// addEventListener("scroll", () => {
	//   const posY = window.scrollY;
	//   if (posY <= prevPosY || posY <= 0) {
	//     header.classList.remove("hide");
	//   } else {
	//     header.classList.add("hide");
	//   }
	//   prevPosY = posY;
	// });
};

export default header;
